export const AUTH_BASE_ROUTE = 'auth';
export const AUTH_BASE_ROUTE_2 = 'compte';
export const AUTH_ROUTES = {
  login: 'connexion',
  register: 'inscription',
  resetPassword: 'reinitialisation-mot-de-passe',
  forgotPassword: 'mot-de-passe-oublie',
};
export const FULL_AUTH_ROUTES = {
  login: `/${AUTH_BASE_ROUTE}/${AUTH_ROUTES.login}`,
  register: `/${AUTH_BASE_ROUTE}/${AUTH_ROUTES.register}`,
  resetPassword: `/${AUTH_BASE_ROUTE}/${AUTH_ROUTES.resetPassword}`,
  forgotPassword: `/${AUTH_BASE_ROUTE}/${AUTH_ROUTES.forgotPassword}`,
};

export const DASHBOARD_ROUTES = {
  home: '',
  wallet: 'wallet',
  claim: 'claim',
  market: 'market',
  referral: 'referral',
  advice: 'conseil',
  documents: 'documents',
  profile: 'profil',
  company: 'pro',
};
export const PROFILE_ROUTES = {
  info: 'informations',
  family: 'famille',
  password: 'securite',
  collaborators: 'collaborateurs',
};
export const WALLET_ROUTES = {
  policies: 'polices',
  updatePolicy: 'update',
  radar: 'radar',
  insurances: 'propositions',
  cancellation: 'resiliation',
};
export const RADAR_ROUTES = {
  health: 'maladie',
  healthComplementary: 'maladie-complementaire',
};

export const DASHBOARD_BASE_ROUTE = '';
export const FULL_DASHBOARD_ROUTES = {
  home: `/${DASHBOARD_BASE_ROUTE}/${DASHBOARD_ROUTES.home}`,
  wallet: `/${DASHBOARD_BASE_ROUTE}/${DASHBOARD_ROUTES.wallet}`,
  claim: `/${DASHBOARD_BASE_ROUTE}/${DASHBOARD_ROUTES.claim}`,
  market: `/${DASHBOARD_BASE_ROUTE}/${DASHBOARD_ROUTES.market}`,
  conseil: `/${DASHBOARD_BASE_ROUTE}/${DASHBOARD_ROUTES.advice}`,
  documents: `/${DASHBOARD_BASE_ROUTE}/${DASHBOARD_ROUTES.documents}`,
  profile: `/${DASHBOARD_BASE_ROUTE}/${DASHBOARD_ROUTES.profile}`,
};
export const BOOKING_URL = 'https://lty-sa.odoo.com/book/87d30d31';
